export default "__VITE_ASSET__J6Z9jpP5__"